module.exports = __webpack_public_path__ + "media/svg/co-0583d4c2.svg";